/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";

const AddComponentLineButton = (props) => {
    const { onClick } = props;

    return (
        <div className='add-component-line-container'>
            <Button className='add-component-line-button' onClick={onClick}>
                <SVGIcons.common.AddOutlined />
            </Button>
        </div>
    );
};

export { AddComponentLineButton };
